import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { apiRequest } from "../../Api/Api";
import { ENDPOINTS } from "../../Api/Endpoints";
import { showAlert } from "../../feedback/feedbackApi";
import "./LanguagePage.scss";
import bg from "../../../src/Assets/backgroundimg.png";

export default function LanguagePage() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const nextRoute = location.state?.nextRoute || "/HealBidDashboard";
  const enforceSelection = Boolean(location.state?.enforceSelection);

  const initialLanguage = useMemo(() => {
    const fromState = String(location.state?.currentLanguage || "").toLowerCase();
    if (["en", "hi", "bn"].includes(fromState)) return fromState;
    const fromStorage = String(localStorage.getItem("lang") || "").toLowerCase();
    if (["en", "hi", "bn"].includes(fromStorage)) return fromStorage;
    return "en";
  }, [location.state?.currentLanguage]);

  const [selected, setSelected] = useState(initialLanguage);
  const [saving, setSaving] = useState(false);

  const handleChange = (lang) => {
    setSelected(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
  };

  const goNext = async () => {
    if (!["en", "hi", "bn"].includes(selected)) {
      showAlert("Please choose a language", { variant: "error" });
      return;
    }

    try {
      setSaving(true);
      await apiRequest({
        method: "POST",
        url: ENDPOINTS.SET_PREFERRED_LANGUAGE,
        data: { preferredLanguage: selected },
      });

      i18n.changeLanguage(selected);
      localStorage.setItem("lang", selected);

      navigate(nextRoute, { replace: true });
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Could not save language preference";
      showAlert(String(message), { variant: "error", title: "Language not saved" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="lang-page" style={{ backgroundImage: `url(${bg})` }}>
      <div className="lang-box">
        <h1>HealBid</h1>
        <p>{t("Welcome to HealBid")}</p>
        <p>{t("Please select Your Preferred Language")}</p>

        <div className="lang-option">
          <label>
            English
            <input
              type="radio"
              name="language-preference"
              checked={selected === "en"}
              onChange={() => handleChange("en")}
            />
          </label>

          <label>
            हिंदी
            <input
              type="radio"
              name="language-preference"
              checked={selected === "hi"}
              onChange={() => handleChange("hi")}
            />
          </label>

          <label>
            বাংলা
            <input
              type="radio"
              name="language-preference"
              checked={selected === "bn"}
              onChange={() => handleChange("bn")}
            />
          </label>
        </div>

        <button className="continue-btn" onClick={goNext} disabled={saving}>
          {saving ? "Saving..." : t("continue")}
        </button>
        {!enforceSelection && (
          <button
            type="button"
            className="continue-btn continue-btn--ghost"
            onClick={() => navigate(nextRoute, { replace: true })}
          >
            Skip for now
          </button>
        )}
      </div>
    </div>
  );
}